// web/src/copilot/AskTapelensButton.tsx
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { AskTapelensSheet } from "./AskTapelensSheet";
import { ASK_TAPELENS_OPEN_EVENT } from "./AskAboutButton";
import { useUsage } from "./api";
import { PaywallModal } from "@/billing/PaywallModal";


const COPILOT_PAYWALL_BULLETS = [
  "Real-time market analysis powered by your dashboard's context",
  "Ask follow-up questions and dig into specific clusters",
  "Premium analysis with the grok-4.3 reasoning model on Analyst",
];


export function AskTapelensButton() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [paywallOpen, setPaywallOpen] = useState(false);
  const { data: usage } = useUsage();
  const tier = usage?.tier ?? "free";

  function onClick() {
    if (tier === "free") {
      setPaywallOpen(true);
      return;
    }
    setSheetOpen(true);
  }

  // External sparkle buttons (AskAboutButton on cluster/analysis cards) open
  // the sheet by dispatching a window event. We listen here so the cards
  // don't need to thread setSheetOpen via context or prop drilling. Free
  // tier still hits the paywall — the agent isn't accessible without a paid
  // tier regardless of entry point.
  useEffect(() => {
    const onOpen = () => {
      if (tier === "free") {
        setPaywallOpen(true);
        return;
      }
      setSheetOpen(true);
    };
    window.addEventListener(ASK_TAPELENS_OPEN_EVENT, onOpen);
    return () => window.removeEventListener(ASK_TAPELENS_OPEN_EVENT, onOpen);
  }, [tier]);

  return (
    <>
      <Button
        onClick={onClick}
        // Slice 2: rendered as a TopBar action (mounted in AppShell's
        // TopBar), so the floating-FAB styling (`fixed bottom-14 right-4
        // z-50 shadow-lg`) is gone. Same Sparkles icon, smaller ghost
        // chip variant so it sits comfortably next to the BellButton.
        variant="ghost"
        size="sm"
        className="gap-1.5"
      >
        <Sparkles className="h-4 w-4" aria-hidden="true" />
        Ask Tapelens
      </Button>
      <AskTapelensSheet open={sheetOpen} onClose={() => setSheetOpen(false)} />
      <PaywallModal
        open={paywallOpen}
        onClose={() => setPaywallOpen(false)}
        title="Tapelens AI"
        description="Real-time market analysis right inside your dashboard."
        bullets={COPILOT_PAYWALL_BULLETS}
      />
    </>
  );
}
